import React from "react"
import { Link, graphql } from "gatsby"

import SEO from "../components/seo"

import AppTemplate from "../components/AppTemplate/AppTemplate"
import Button from "@material-ui/core/Button"
import KeyboardBackspaceRounded from "@material-ui/icons/KeyboardBackspaceRounded"
import ArrowRightAltRounded from "@material-ui/icons/ArrowRightAltRounded"

import styles from "./BlogPost.module.scss"

const BlogPostTemplate = ({ data, pageContext }) => {
  const post = data.markdownRemark
  const { previous, next } = pageContext
  const { author, thumbnailImage } = post.frontmatter

  return (
    <AppTemplate>
      <SEO
        title={post.frontmatter.title}
        description={post.frontmatter.description || post.excerpt}
        thumbnailImage={thumbnailImage}
      />
      <div className={styles.row}>
        <Link
          style={{
            boxShadow: `none`,
            color: `inherit`,
          }}
          to="/"
        >
          <button
            variant="text"
            type="button"
            style={{
              textTransform: "lowercase",
              fontFamily: "var(--heading-font-family)",
              color: "var(--blue)",
              fontSize: "var(--text-sm)",
              border: "none",
              cursor: "pointer",
              padding: "var(--space-2xs)",
              backgroundColor: "transparent",
            }}
            size="small"
          >
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <KeyboardBackspaceRounded
                style={{ width: "20px", maxHeight: "20px" }}
              />

              <span
                style={{
                  marginLeft: "var(--space-xs)",
                }}
              >
                all posts
              </span>
            </div>
          </button>
        </Link>
      </div>

      <article className={styles.blogPost}>
        <header>
          <small
            style={{
              color: "var(--grey-5)",
            }}
          >
            {post.frontmatter.date}
          </small>

          <h1
            style={{
              marginTop: "var(--space-2xs)",
              marginBottom: "var(--space-2xs)",
            }}
          >
            {post.frontmatter.title}
          </h1>
        </header>

        <img
          className={styles.blogPost_thumbnailImage}
          src={thumbnailImage}
          alt={post.frontmatter.title}
        />

        <div className={styles.blogPost_mainContent}>
          {author && (
            <a
              href={`https://devchallenges.io/profile/${author.devchallengesId}`}
            >
              <div className={styles.blogPost_author}>
                <img src={author.profilePicture} alt={author.name} />
                <p>{author.name}</p>
              </div>
            </a>
          )}
          <section dangerouslySetInnerHTML={{ __html: post.html }} />
        </div>
      </article>

      <nav className={styles.row}>
        <ul
          style={{
            display: `flex`,
            flexWrap: `wrap`,
            justifyContent: `space-between`,
            listStyle: `none`,
            padding: 0,
          }}
        >
          <li>
            {previous && (
              <Link
                style={{
                  boxShadow: `none`,
                  color: `inherit`,
                }}
                to={previous.fields.slug}
              >
                <Button
                  variant="text"
                  type="button"
                  style={{
                    textTransform: "lowercase",
                    fontFamily: "var(--heading-font-family)",
                    color: "var(--blue)",
                    fontSize: "var(--text-sm)",
                  }}
                  size="small"
                  startIcon={<KeyboardBackspaceRounded />}
                >
                  {previous.frontmatter.title}
                </Button>
              </Link>
            )}
          </li>
          <li>
            {next && (
              <Link
                style={{
                  boxShadow: `none`,
                  color: `inherit`,
                }}
                to={next.fields.slug}
              >
                <Button
                  variant="text"
                  type="button"
                  style={{
                    textTransform: "lowercase",
                    fontFamily: "var(--heading-font-family)",
                    color: "var(--blue)",
                    fontSize: "var(--text-sm)",
                  }}
                  size="small"
                  endIcon={<ArrowRightAltRounded />}
                >
                  {next.frontmatter.title}
                </Button>
              </Link>
            )}
          </li>
        </ul>
      </nav>
    </AppTemplate>
  )
}

export default BlogPostTemplate

export const pageQuery = graphql`
  query BlogPostBySlug($slug: String!) {
    site {
      siteMetadata {
        title
      }
    }
    markdownRemark(fields: { slug: { eq: $slug } }) {
      id
      excerpt(pruneLength: 160)
      html
      frontmatter {
        title
        date(formatString: "MMMM DD, YYYY")
        description
        thumbnailImage
        author {
          bio
          id
          profilePicture
          name
          devchallengesId
        }
      }
    }
  }
`
